export const grid = () => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr 1fr',
    gridTemplateAreas: '"email accountSlug" "apiToken apiToken"',
    gridGap: '1.5rem 1rem',
});
